function iconMapping(name) {
    // convert mime type to file type name
  switch (name) {
    //pdf
    case "application/pdf":
      return "PDF";
    //aac
    case "audio/aac":
      return "AAC";
    //image
    case "image/apng":
    case "image/png":
      return "PNG";
    //video
    case "video/x-msvideo":
      return "AVI";

    //css
    case "text/css":
      return "CSS";
    //csv
    case "text/csv":
      return "CSV";

    //doc
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "DOC";

    //gif
    case "image/gif":
      return "GIF";

    //html
    case "text/html":
      return "HTML";

    //jpeg
    case "image/jpeg":
      return "JPEG";

    //js
    case "text/javascript":
      return "JS";

    //json
    case "application/json":
    case "application/ld+json":
      return "JSON";

    //mp3
    case "audio/mpeg":
      return "MP3";

    //mp4
    case "video/mp4":
      return "MP4";
    //mpeg
    case "video/mpeg":
      return "MPEG";

    //odp
    case "application/vnd.oasis.opendocument.presentation":
      return "ODP";

    //ods
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "ODS";
    //odt
    case "application/vnd.oasis.opendocument.text":
      return "ODT";

    //php
    // case 'application/x-httpd-php':
    //     return phpIcon;

    //ppt
    case "application/vnd.ms-powerpoint":
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "PPT";

    //rtf
    case "application/rtf":
      return "RTF";

    //svg
    case "	image/svg+xml":
      return "SVG";

    //text
    case "text/plain":
      return "TXT";

    //wav
    case "audio/wav":
      return "WAV";

    //xls
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "XLS";

    //xml
    case "application/xml ":
      return "XML";

    case "aiplan/flow":
      return "AI PLAN FLOW";
    case "aiplan/data":
      return "AI PLAN DATA";
    case "aiplan/package":
      return "AI PLAN PACKAGE";
    case "aiplan/macro":
      return "AI PLAN MACRO";
    case "aiplan/datasource":
      return "AI PLAN DATASOURCE";
    case "application/x-iwork-keynote-sffkey":
      return "KEYNOTE";
    case "application/x-iwork-pages-sffpages":
      return "PAGES";
    case "application/x-iwork-numbers-sffnumbers":
      return "NUMBERS";
    default:
      return "N/A";
  }
}

export { iconMapping };
